import { useMemo } from 'react'
import cn from 'classnames'

import { ContentSteps, useStepFlow } from 'src/lib/useStepFlow'

import { FirstStep, FourthStep, SecondStep, ThirdStep } from './ui/steps'

import Logo from '../../icons/logo.webp'

import { normalizeBrowserLang, TLang } from 'src/constants/langs'

import styles from './styles.module.scss'

const stepComponents = {
    [ContentSteps.FIRST]: FirstStep,
    [ContentSteps.SECOND]: SecondStep,
    [ContentSteps.THIRD]: ThirdStep,
    [ContentSteps.FOURTH]: FourthStep,
}

const Bonanza = () => {
    const { step, goToNextStep } = useStepFlow()
    const StepComponent = stepComponents[step]

    const currentLang = useMemo<TLang>(() => {
        const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
        return normalizeBrowserLang(nav)
    }, [])

    return (
        <div
            className={cn(styles.root, {
                [styles['root--el']]: currentLang === 'el',
            })}
        >
            {(step === ContentSteps.SECOND || step === ContentSteps.FOURTH) && (
                <div className={styles.root__blur} />
            )}
            <img src={Logo} alt="Logo" className={styles.logo_wrapper} />

            <div
                className={cn(
                    styles.container,
                    styles[`container--${step}`],
                    styles[`container--${step}--${currentLang}`],
                    {
                        [styles[`container--${currentLang}`]]:
                            currentLang === 'el',
                    },
                )}
            >
                <StepComponent
                    onNext={goToNextStep}
                    step={step}
                    lang={currentLang}
                />
            </div>
        </div>
    )
}

export default Bonanza
